import { type Translator } from 'locale';
import { findAndMap } from 'utils/array';

interface ErrorRef {
  message?: unknown;
  type?: unknown;
}

/**
 * Every single validation error will either
 * be directly from the zod issue type or custom
 * keys we pass in directly on validator definition (check email on ./schema)
 *
 * If we ever need custom errors with value interpolation etc,
 * we'll adjust the integration. No need for that atm.
 */
function translateRef(ref: string, t: Translator) {
  if (!ref) return;

  const key = `form-errors.${ref}`;

  const translated = t(key);

  if (translated !== key) return translated;
}

export function translateError(error: ErrorRef | undefined, t: Translator) {
  if (!error) return;

  const { message, type } = error;

  const targets = [message, type].filter((t) => typeof t === 'string');

  const translated = findAndMap(targets, (msg) => translateRef(msg || '', t));

  const result = translated || message;

  if (typeof result === 'string') return result;
}
